module.exports = __webpack_public_path__ + "static/media/failed.b6b32044.svg";